export const getAllToasts = 'getAllToasts';
